// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticProxies_residential_container__1oCyV {
  height: 100%;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b {
  width: 100%;
  height: 100%;
  position: relative;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_title__v1P8Y {
  color: var(--font-color);
  display: none;
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 16px 10px 10px 20px;
}
@media (max-width: 781px) {
  .StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_title__v1P8Y {
    display: block;
  }
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt {
  width: calc(100% - 40px);
  border-top: 1px solid var(--re-mobile-title-border-bg);
  display: none;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 12px;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt .StaticProxies_active__wOsyf {
  background-color: var(--re-mobile-tab-hover-bg);
  color: var(--bg-color);
}
@media (max-width: 781px) {
  .StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt {
    display: flex;
  }
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt button {
  height: 26px;
  background-color: var(--re-mobile-tab-bg);
  border: 1px solid transparent;
  border-radius: 7px;
  color: #6F767E;
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-right: 6px;
  padding: 3px 9px 4px 8px;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt button:hover,
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_tab__UpxMt button:active {
  background-color: var(--re-mobile-tab-hover-bg);
  color: var(--bg-color);
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 .StaticProxies_purchase__q\\+eB3 {
  width: 30%;
}
.StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 .StaticProxies_order__7nN4- {
  width: 70%;
}
@media screen and (max-width: 1220px) {
  .StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 .StaticProxies_purchase__q\\+eB3,
  .StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 .StaticProxies_order__7nN4- {
    width: 100%;
  }
}
@media screen and (max-width: 781px) {
  .StaticProxies_residential_container__1oCyV .StaticProxies_residential__6UK0b .StaticProxies_container__BjDf9 .StaticProxies_order__7nN4- {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/StaticProxies/StaticProxies.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AADI;EACE,wBAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AAGN;AADM;EAVF;IAWI,cAAA;EAIN;AACF;AADI;EACE,wBAAA;EACA,sDAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAGN;AADM;EACE,+CAAA;EACA,sBAAA;AAGR;AAAM;EAbF;IAcI,aAAA;EAGN;AACF;AADM;EACE,YAAA;EACA,yCAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;AAGR;AAAM;;EAEE,+CAAA;EACA,sBAAA;AAER;AAGI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AADN;AAEM;EACE,UAAA;AAAR;AAGM;EACE,UAAA;AADR;AAIM;EACE;;IAEE,WAAA;EAFR;AACF;AAKM;EACE;IACE,aAAA;EAHR;AACF","sourcesContent":[".residential_container {\n  height: 100%;\n  .residential {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    .title {\n      color: var(--font-color);\n      display: none;\n      font-family: Red Hat Display;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      padding: 16px 10px 10px 20px;\n  \n      @media (max-width: 781px) {\n        display: block;\n      }\n    }\n  \n    .tab {\n      width: calc(100% - 40px);\n      border-top: 1px solid var(--re-mobile-title-border-bg);\n      display: none;\n      margin-left: 20px;\n      margin-right: 20px;\n      padding-top: 12px;\n  \n      .active {\n        background-color: var(--re-mobile-tab-hover-bg);\n        color: var(--bg-color);\n      }\n  \n      @media (max-width: 781px) {\n        display: flex;\n      }\n  \n      button {\n        height: 26px;\n        background-color: var(--re-mobile-tab-bg);\n        border: 1px solid transparent;\n        border-radius: 7px;\n        color: #6F767E;\n        font-family: Red Hat Display;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        margin-right: 6px;\n        padding: 3px 9px 4px 8px;\n      }\n  \n      button:hover,\n      button:active {\n        background-color: var(--re-mobile-tab-hover-bg);\n        color: var(--bg-color);\n      }\n  \n    }\n  \n    .container {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-wrap: wrap;\n      .purchase {\n        width: 30%;\n      }\n  \n      .order {\n        width: 70%;\n      }\n  \n      @media screen and (max-width: 1220px) {\n        .purchase,\n        .order {\n          width: 100%;\n        }\n      }\n  \n      @media screen and (max-width: 781px) {\n        .order {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"residential_container": `StaticProxies_residential_container__1oCyV`,
	"residential": `StaticProxies_residential__6UK0b`,
	"title": `StaticProxies_title__v1P8Y`,
	"tab": `StaticProxies_tab__UpxMt`,
	"active": `StaticProxies_active__wOsyf`,
	"container": `StaticProxies_container__BjDf9`,
	"purchase": `StaticProxies_purchase__q+eB3`,
	"order": `StaticProxies_order__7nN4-`
};
export default ___CSS_LOADER_EXPORT___;
